/**
 * Display of a date with an associated date selector that allows
 * the user to change the date.  Note if you want an <input type="date"> you
 * want date-input, not this
 */

import Backbone from 'backbone'

import template from 'scoreboard/components/period-display.hbs'
import DateSelector from './date-selector'
import momentHelper from 'scoreboard/components/moment-helper'
import i18n from 'scoreboard/components/i18n'
import Tooltip from 'scoreboard/components/tooltip'
import _ from 'lodash'
import select from 'scoreboard-select'
import constants from 'scoreboard/components/constants'

var DateDisplay = Backbone.View.extend({

	tagName: 'ul',

	events: {
		'click .dropdown': 'selector'
	},

	initialize: function(options) {
		this.appliesTo = options && options.appliesTo
	},

	render: function() {
		this.$el.empty().append(template())
		this.refresh(this.appliesTo)
		select(this.el.querySelectorAll('select'))

		return this
	},

	// refresh the display of the date
	refresh: function(appliesTo) {
		this.appliesTo = appliesTo
		this.update(appliesTo)
	},

	// update the displayed date
	update: function(appliesTo) {
		var text
		if (appliesTo) {
			text = momentHelper.formatDate(appliesTo)
		} else {
			text = i18n.get('common.allTime')
		}
		this.$('.dropdown a .text').text(text)
	},

	selector: function() {
		if (this.disabled) {
			return
		}
		if (this.selectorTooltip && !this.selectorTooltip.removed) {
			this._removeTooltip()
			return
		}

		this.dateSelector = new DateSelector({ appliesTo: this.appliesTo })

		let attachTo = this.$('.dropdown')
		this.selectorTooltip = new Tooltip({
			content: this.dateSelector,
			attachTo,
			placement: 'below',
			arrow: 'right',
			adjustment: -(this.$('.dropdown').width()/2) + constants.STANDARD_MARGIN, // This shifts the tooltip arrow directly underneath the down arrow
			extraClass: 'time-selector time-selector-date',
			closeOnChangedFocus: false
		}).render()

		this.dateSelector.on('change:date', function(appliesTo) {
			this.changeDate(appliesTo)
			this._removeTooltip()
		}.bind(this))
	},

	changeDate: function(newAppliesTo) {
		this.refresh(newAppliesTo)
		if (this.appliesTo != newAppliesTo) {
			this.trigger('change:date', newAppliesTo)
		}
	},

	_removeTooltip: function () {
		_.invokeMap([this.dateSelector, this.selectorTooltip], 'remove')
		delete this.dateSelector
		delete this.selectorTooltip
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this._removeTooltip()
	}

})

export default DateDisplay

DateDisplay.__filename__ = 'notes/date-display.js'
